"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var search = window.location.search;

function _default(route) {
  return "" + route + search;
}

module.exports = exports.default;